/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobPositionControllerCreateBulkRequestJobPositionsInner } from './jobPositionControllerCreateBulkRequestJobPositionsInner';


export interface JobPositionControllerCreateBulkRequest { 
    jobPositions: Array<JobPositionControllerCreateBulkRequestJobPositionsInner>;
    /**
     * Si es true, detiene el proceso en el primer error. Si es false, continúa procesando todos los elementos.
     */
    stopOnFirstError?: boolean;
}

